import moment from 'moment'

import messages from './messages'


export const defaultCategories = [
  { value: 'under 17', max: 17, label: messages.ageOptions.le17 },
  { value: '18 to 24', min: 18, max: 24, label: messages.ageOptions.from18to24 },
  { value: '25 to 34', min: 25, max: 34, label: messages.ageOptions.from25to34 },
  { value: '35 to 44', min: 35, max: 44, label: messages.ageOptions.from35to44 },
  { value: '45 to 54', min: 45, max: 54, label: messages.ageOptions.from45to54 },
  { value: '55 to 64', min: 55, max: 64, label: messages.ageOptions.from55to64 },
  { value: '65 or older', min: 65, label: messages.ageOptions.from65 },
]

export const defaultCategoriesWithNotAnswer = [
  ...defaultCategories,
  { value: '', label: messages.ageOptions.notAnswer },
]

export const ageCategoryEnum = {
  'under 17': 'LE17',
  '18 to 24': 'FROM18TO24',
  '25 to 34': 'FROM25TO34',
  '35 to 44': 'FROM35TO44',
  '45 to 54': 'FROM45TO54',
  '55 to 64': 'FROM55TO64',
  '65 or older': 'FROM65',
}

type Categories = {
  value: string
  min?: number
  max?: number
}[]

/**
 * Returns age category from birthday
 * @param birthday
 * @param categories
 */
const getAgeCategoryFromBirthday = (birthday: string, categories: Categories = defaultCategories) => {
  if (!birthday) {
    return null
  }

  const age = moment().diff(birthday, 'years')
  let category = null

  categories.some(({ value, min, max }) => {
    const hasCategory = (!Boolean(min) || age >= min) && (!Boolean(max) || age <= max)

    if (hasCategory) {
      category = value
    }

    return hasCategory
  })

  return category
}

export default getAgeCategoryFromBirthday
